/** @jsxImportSource @emotion/react */
import useSWR from 'swr';
import React from 'react';
// eslint-disable-next-line no-unused-vars
import tw from 'twin.macro';
import { useLocation } from 'react-router-dom';
import { swrfetcher } from '../../utils/swrFetcher';
import DataGridViewTemp from '../Common/DataGridViewTemp';

const MerchantList = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const offset = query.get('offset');

  const token = JSON?.parse(
    localStorage.getItem('token') || sessionStorage.getItem('token')
  );

  const userType = JSON?.parse(
    localStorage.getItem('userType') || sessionStorage.getItem('userType')
  ).toLowerCase();

  const tableUrl =
    userType === 'admin'
      ? `/apis/v1/bizzdesk/terminals/analytics/getTerminalsByMerchant?limit=30&offset=${
          offset || 0
        }`
      : `/apis/bizzdesk/organization/terminals/getTerminalsByMerchant?limit=10&offset=${
          offset || 0
        }`;

  const tableCountUrl =
    userType === 'admin'
      ? `/apis/v1/bizzdesk/terminals/analytics/getTerminalsByMerchant/count?limit=30&offset=${
          offset || 0
        }`
      : `/apis/bizzdesk/organization/terminals/getTerminalsByMerchant/count?limit=10&offset=${
          offset || 0
        }`;

  const { data: val, isValidating } = useSWR(
    [tableUrl, token, 'GET'],
    ([url, USER_TOKEN, method]) => swrfetcher(url, USER_TOKEN, method)
  );

  const { data: tableCount } = useSWR(
    [tableCountUrl, token, 'GET'],
    ([url, USER_TOKEN, method]) => swrfetcher(url, USER_TOKEN, method)
  );

  let rows = [];
  if (val) {
    if (val?.status >= 400) {
      rows = [];
    } else {
      rows = val?.map((item, index) => {
        return {
          id: index + 1,
          agent: item?.agent,
          noOfterminals: item?.noOfTerminals,
          action: { link: true },
        };
      });
    }
  }

  const TransWalletColumn = [
    {
      headerName: 's/n',
    },
    {
      headerName: 'BUSINESS MERCHANTS',
    },
    {
      headerName: 'terminals',
    },
    {
      headerName: 'Action',
    },
  ];

  return (
    <div tw="mb-10 -mt-10">
      <DataGridViewTemp
        rows={rows}
        columns={TransWalletColumn}
        isValidating={isValidating}
        hasExportBtn={val}
        pagination
        recordCount={tableCount || 0}
        page={offset / 30 + 1}
      >
        <div tw="grid grid-auto-columns[auto] gap-4 w-full xl:(flex items-center space-y-0 space-x-4)" />
      </DataGridViewTemp>
    </div>
  );
};

export default MerchantList;
